<template>
  <div class="container">
    <custom-select :value="value" @input="onChange" :items="fechas" />
  </div>
</template>

<script>
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "DateProposal",
  components: { CustomSelect },
  props: {
    value: String
  },
  computed: {
    fechas() {
      let fechas = [];
      fechas.push({ label: "prueba", value: "prueba" });

      return fechas;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    }
  }
};
</script>
